export const TOOLTIP_VISIBLE_DURATION = 1500;
